/* Continuous brand wheel: 2.5x the original speed, with touch/mouse dragging. */
(() => {
  if (window.fbBrandWheelInit) { window.fbBrandWheelInit(document); return; }
  function init(root) {
    root.querySelectorAll('[data-fb-brand-wheel]:not([data-wheel-ready])').forEach(wheel => {
      const track = wheel.querySelector('.fb-brand-track');
      const group = wheel.querySelector('.fb-brand-group');
      if (!track || !group) return;
      wheel.dataset.wheelReady = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let width = 0, offset = 0, previous = 0, frame, pointer, moved = false, velocity = 0;
      const measure = () => { width = group.getBoundingClientRect().width; };
      const paint = () => {
        if (!width) return;
        offset = ((offset % width) + width) % width;
        track.style.transform = `translate3d(${-offset}px,0,0)`;
      };
      const observer = new ResizeObserver(measure); observer.observe(group); measure();
      const tick = now => {
        if (!wheel.isConnected) { observer.disconnect(); cancelAnimationFrame(frame); return; }
        const dt = Math.min((now - (previous || now)) / 1000, .05); previous = now;
        if (!pointer && !reduced.matches && !wheel.matches(':focus-visible') && !wheel.querySelector(':focus-visible')) {
          const count = group.children.length || 1;
          offset += (width / (count * 1.6) + velocity) * dt;
          velocity *= Math.exp(-1.5 * dt); paint();
        }
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
      wheel.addEventListener('dragstart', e => e.preventDefault());
      wheel.addEventListener('pointerdown', e => {
        if (e.button !== 0 || !e.isPrimary) return;
        pointer = {id:e.pointerId,x:e.clientX,y:e.clientY,last:e.clientX,time:e.timeStamp};
        moved = false; velocity = 0;
      });
      wheel.addEventListener('pointermove', e => {
        if (!pointer || pointer.id !== e.pointerId) return;
        if (!moved) {
          if (Math.abs(e.clientY-pointer.y) > Math.abs(e.clientX-pointer.x) && Math.abs(e.clientY-pointer.y)>6) {pointer=null;return;}
          if (Math.abs(e.clientX-pointer.x)<6) return;
          moved = true; wheel.setPointerCapture(e.pointerId); wheel.classList.add('is-dragging');
        }
        const delta = pointer.last-e.clientX;
        offset += delta; velocity = velocity * .3 + .7 * Math.max(-3200,Math.min(3200,delta/Math.max(.008,(e.timeStamp-pointer.time)/1000)));
        pointer.last=e.clientX;pointer.time=e.timeStamp;paint();
      });
      const end = e => {
        if (!pointer || pointer.id !== e.pointerId) return;
        if(wheel.hasPointerCapture(e.pointerId)) wheel.releasePointerCapture(e.pointerId);
        pointer=null;wheel.classList.remove('is-dragging');
      };
      wheel.addEventListener('pointerup',end);wheel.addEventListener('pointercancel',end);wheel.addEventListener('lostpointercapture',end);
      wheel.addEventListener('pointerleave', e => {if(!moved)end(e);});
      wheel.addEventListener('click', e => {if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
      wheel.addEventListener('keydown', e => {
        if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();offset+=(e.key==='ArrowRight'?1:-1)*150;paint();}
      });
    });
  }
  window.fbBrandWheelInit=init;init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
